import { KYC_OPERATOR_NAMES, type KycOperatorName } from '@/shared/Kyc/types';

export const isValidKycOperator = (
  operatorName?: KycOperatorName,
): operatorName is KycOperatorName => {
  if (!operatorName) {
    return false;
  }

  return KYC_OPERATOR_NAMES.includes(operatorName as KycOperatorName);
};
